<template>
    <div>
        <el-drawer v-model="param.view" :with-header="false" size="500" direction="ltr" :before-close="closewindow">
            <div>
                <el-form :inline="true">
                    <el-form-item>
                    <div class="TTL-input">
                    <el-input v-model="param.key" placeholder="医院名称 / 所在地址" round size="large" prefix-icon="Search" clearable @change="param.ischange=true"/>
                    </div>
                    </el-form-item>
                    <el-form-item>
                    <el-button type="warning" size="large" round @click="gethospitallist">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                    <el-button type="warning" size="large" round @click="addhospital">新增</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="prenatal-main">
                <el-empty description="还没有记录" v-if="hospitallists.length > 0 ? false : true" />
                <ul class="TTL-hospital-main" v-loading="param.loading">
                    <li v-for="(item,index) in hospitallists">
                        <div class="TTL-hospital-name">{{item.name}}</div>
                        <div class="TTL-hospital-address">{{item.address}}</div>
                        <a class="TTL-prenatal-edit" @click="edithospital(item)"></a>
                        <a class="TTL-prenatal-close" @click="closehospital(item)"></a>
                    </li>
                </ul>
                <div class="block TTL-page-block" v-if="hospitallists.length > 0">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="param.p"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="param.rollpage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="param.row"
                    />
                </div>
            </div>
        </el-drawer>


        <!-- 自定义组件 -->
        <AddOrEditHospital :value="addoreditparam.view" :data="addoreditparam.data" @hospitalfinish="hospitalfinish" />


    </div>
</template>


<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_MODEL_GENEALOGY from '@/Interface/Genealogy/home';
import AddOrEditHospital from '@/views/Home/Module/AddOrEditHospital.vue';
export default {
    props: ['value'],
    components:{AddOrEditHospital},
    data() {
        return {
            
            param: {
                view:false,
                key:'',
                loading:false,
                ischange:false,
                p:1,
                rollpage:10,
                row:0,
            },

            hospitallists:[
                {id:1,name:'广西自治区人民医院',address:'广西南宁市桃源路中'},
                {id:2,name:'南宁红十字医院',address:'广西南宁市桃源路中'},
            ],

            addoreditparam: {
                view:false,
                data:{}
            },

        }
    },

    watch: {
        value(val) {
            if(val) {
                this.param.view=true;
                this.resethospitalparam(); //重置提交参数
                this.gethospitallist(); //获取就医医院列表
            }
        },
    },

    mounted() {
        
    },

    methods: {


        /** 删除医院 **/
        closehospital(item) {
            let id=item.id;
            this.$confirm.confirm(
                '您确定要删除该医院 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            )
            .then(()=> {
                INTERFACE_MODEL_GENEALOGY.DEL_HOSPITAL({id:item.id}).then((res) => {
                    if(res.status > 0) return false;
                    this.gethospitallist();
                });
            })
            .catch(()=> {
                
            });
        },


        /** 新增医院信息 **/
        addhospital() {
            this.addoreditparam.view=true;
            this.addoreditparam.data={};
        },


        /** 编辑医院信息 **/
        edithospital(item) {
            this.addoreditparam.view=true;
            this.addoreditparam.data=item;
        },


        /** 医院数据回调 **/
        hospitalfinish() {
            this.addoreditparam.view=false;
            this.gethospitallist();
        },


        /** 获取就医医院列表 **/
        gethospitallist() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }
            
            this.param.loading=true;
            this.hospitallists=[];
            INTERFACE_MODEL_GENEALOGY.GET_HOSPITAL_LIST(this.param).then((res) => {
                this.param.loading=false;
                if(res.status > 0) return false;

                this.hospitallists=res.data.list;
                this.param.row=res.data.count;
            });
        },


        /** 调整每页条数 **/
        handleSizeChange(e) {
            this.param.rollpage=e;
            this.gethospitallist();
        },


        /** 调整页数 **/
        handleCurrentChange(e) {
            this.param.p=e;
            this.gethospitallist();
        },


        /** 重置提交参数 **/
        resethospitalparam() {
            this.param.name='';
            this.param.p=1;
            this.param.rollpage=10;
            this.param.row=0;
            this.param.ischange=false;
        },


        /** 关闭窗口前回调函数 **/
        closewindow() {
            this.param.view=false;
            this.$emit('hospitalfinish');
        },

    },

}
</script>
<style scoped>
.TTL-dialog {text-align:left !important;}
.TTL-setting-image-detail {width:80px;height:80px;text-align:center;margin:0 auto;}
.TTL-setting-image-detail .el-image {width:80px;height:80px;border-radius:50%;}
.TTL-hospital-main {float:left;width:100%;margin-top:10px;}
.TTL-hospital-main li {list-style: none;float:left;width:calc(100% - 20px);padding:10px;border-radius:6px;border-bottom:1px solid #F0F2F5;Position:relative;transition:.5s all;}
.TTL-hospital-main li:hover {background:#F0F2F5;}
.TTL-hospital-name {color:#303133;float:left;padding:5px 30px;width:calc(100% - 60px);font-size:13px;line-height:23px;background:url(@/assets/icon/hospital.png) no-repeat;background-size:20px;background-position:0 center;}
.TTL-hospital-address {padding:5px 0 5px 20px;width:calc(100% - 20px);line-height:23px;margin-bottom:5px;font-size:12px;color:#606266;background:url(@/assets/icon/address.png) no-repeat;background-size:15px;background-Position:0 center;display:flex;align-items:center;}
.TTL-prenatal-close {width:25px;height:25px;Position:absolute;top:0;right:0;margin-top:15px;margin-right:10px;border-radius:50%;background:#F56C6C url(@/assets/icon/close.png) no-repeat;background-size:8px;background-position:center}
.TTL-prenatal-edit {width:25px;height:25px;Position:absolute;top:0;right:0;margin-top:15px;border-radius:50%;margin-right:40px;background:#E6A23C url(@/assets/icon/edit.png) no-repeat;background-size:12px;background-position:center;}
.TTL-page-block {float:left;width:100%;margin-top:20px;padding:20px 0;}
.TTL-page-block .el-pagination {font-size:13px !important;}
</style>